function hashCode(str) {
  let hash = '';
  for (let i = 0; i < str.length; i += 1) {
    hash += ((str.toUpperCase().charCodeAt(i) - 65) * 10).toString(16);
  }
  return hash;
}

export default {
  generate(str) {
    const c = hashCode(str).toUpperCase();
    return c.length > 6 ? c.substr(0, 6) : '00000'.substring(0, 6 - c.length) + c;
  },
};
